
export default function AboutSection() {
  const expertise = [
    { name: 'QuickBooks', icon: 'ri-calculator-line', years: '10+' },
    { name: 'Microsoft Business Central', icon: 'ri-database-2-line', years: '8+' },
    { name: 'Oracle', icon: 'ri-server-line', years: '12+' },
    { name: 'SAP', icon: 'ri-stack-line', years: '15+' }
  ];

  const stats = [
    { number: '500+', label: 'Clientes Satisfechos' },
    { number: '99.9%', label: 'Tasa de Precisión' },
    { number: '24/7', label: 'Soporte Disponible' },
    { number: '15+', label: 'Años de Experiencia' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Su Socio de Confianza en Contabilidad
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Con más de 15 años de experiencia en gestión financiera, ledgRkeepR se especializa en 
              servicios de contabilidad subcontratados para empresas de todos los tamaños. Nuestro equipo de 
              profesionales certificados garantiza precisión, cumplimiento y tranquilidad para sus operaciones financieras.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Entendemos que cada negocio es único, por eso ofrecemos soluciones flexibles 
              adaptadas a sus necesidades específicas, ya sea un emprendedor individual o manejando un 
              equipo en crecimiento de hasta 10 empleados.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/514e588715e3cbceb035d0631187781b.jpg" 
              alt="Servicios profesionales de contabilidad"
              className="rounded-xl shadow-2xl object-cover object-top w-full"
            />
          </div>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">Experiencia en Plataformas</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-lg p-8 text-center shadow-md hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-database-2-line text-3xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Microsoft Business Central</h4>
              <p className="text-lg text-blue-600 font-bold mb-2">15+ años</p>
              <p className="text-sm text-gray-600">
                Experiencia especializada en implementación, personalización e integración de Microsoft Business Central
              </p>
            </div>
            
            <div className="space-y-6">
              <div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">
                  Experiencia Profunda en Microsoft Business Central
                </h4>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Con más de 15 años de experiencia dedicada en Microsoft Business Central, proporcionamos 
                  soluciones integrales que van más allá de la contabilidad básica. Nuestro equipo entiende 
                  las complejidades de los módulos financieros de Microsoft Business Central y puede optimizar su sistema para máxima eficiencia.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-settings-3-line text-blue-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Implementación Personalizada</h5>
                    <p className="text-gray-600 text-sm">
                      Configuración y setup de Microsoft Business Central adaptado a sus procesos únicos de negocio y requisitos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-link text-green-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Integración SharePoint</h5>
                    <p className="text-gray-600 text-sm">
                      Gestión de documentos sin problemas a través de nuestra extensión propietaria Microsoft Business Central-SharePoint para colaboración mejorada.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-bar-chart-line text-purple-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Reportes Avanzados</h5>
                    <p className="text-gray-600 text-sm">
                      Reportes financieros personalizados y dashboards que aprovechan las poderosas capacidades analíticas de Microsoft Business Central.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-shield-check-line text-orange-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Cumplimiento y Seguridad</h5>
                    <p className="text-gray-600 text-sm">
                      Asegure que su entorno Microsoft Business Central cumpla con todos los requisitos regulatorios con nuestra experiencia en cumplimiento.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}